import styled from 'styled-components';
import Card from '@glowforge/gf-styled/components/card/card.styles';
import Button from '@glowforge/gf-styled/components/button/button-base';
import {
  Title,
  Paragraph,
} from '@glowforge/gf-styled/components/typography/Typography';
import { GridContainer } from '@glowforge/gf-styled/components/grid-container';
import SVG from '@glowforge/gf-styled/components/svg';

/**
 * TODO: Extract Grid based card from comparison-table-with-images
 * into common card component. Did not do for expediency sake of launch.
 */
import {
  CardBackground as CardBackgroundOther,
  CardContent as CardContentOther,
  CardWrapper as CardWrapperOther,
  TopImage as TopImageOther,
} from '../comparison-table-with-images/comparison-table-with-images-rebrand.styles';

export const TopImage = styled(TopImageOther)`
  && {
    position: relative;
    display: flex;
    grid-row: TopImage / TopImageEnd;

    img {
      max-height: 100%;
      margin: 0 auto;
    }
  }
`;

export const TopImageInnerWrapper = styled('div')`
  width: 100%;
`

export const LogoImage = styled(SVG)`
  width: 100%;

  && text {
    font-family: 'Space Grotesk', sans-serif;
  }
`;

export const ProductInfo = styled('div')`
  padding: 0 24px 8px 24px;

  > ${Paragraph} {
    color: ${(props) => props.theme.colors.slate.base};
    margin-top: 12px;
    text-align: center;
    line-height: 1.5rem;
  }

  ${Button} {
    opacity: 1;
    z-index: 1;
    margin: 24px auto 36px;

    @media ${(props) => props.theme.queries.desktopAndUp} {
      opacity: 0;
      transition: 0.25s opacity;
    }
  }
`;

export const ButtonLinkWrapper = styled('div')`
  display: flex;
`

export const CardBackground = styled(CardBackgroundOther)`
  @media ${(props) => props.theme.queries.desktopAndUp} {
    opacity: 0;
    transition: 0.25s opacity;
  }
`;

export const CardLink = styled('a')`
  text-decoration: none;

  &:hover {
    ${CardBackground} {
      opacity: 1;
    }
    ${ProductInfo} {
      ${Button} {
        opacity: 1;
      }
    }
  }
`;

export const CardContent = styled(CardContentOther)``;

export const MobileCard = styled(Card)`
  display: inherit;

  @media ${(props) => props.theme.queries.desktopAndUp} {
    display: none;
  }
`;

export const CardWrapper = styled(CardWrapperOther)`
  @media ${(props) => props.theme.queries.desktopDown} {
    display: grid;
    grid-template-rows:
      [TopImage] ${(props) => ((props?.imgHeight ?? 0) * 50) / 622}px
      [CardStart] ${(props) => ((props?.imgHeight ?? 0) * 572) / 622}px
      [TopImageEnd] min-content
      [CardEnd];
  }
`;

export const ProductsWrapper = styled('div')`
  display: grid;
  gap: 50px;
  grid-column: main-start / main-end;

  ${CardLink}:nth-child(2) {
    order: 1;
  }

  ${CardLink}:nth-child(1), ${CardLink}:nth-child(3) {
    order: 2;
  }

  @media ${(props) => props.theme.queries.desktopAndUp} {
    gap: 16px;
    grid-template-columns: repeat(3, 1fr);

    ${CardLink}:nth-child(2) {
      order: 1;
    }

    ${CardLink}:nth-child(1), ${CardLink}:nth-child(3) {
      order: 1;
    }
  }
`;

export const MeetFamilyWrapper = styled(GridContainer)`
  padding: 36px 0;
  background-color: ${(props) => props.theme.colors.backgrounds.gray};

  > ${Title} {
    text-align: left;
    padding-bottom: 48px;
    grid-column: main-start / main-end;
  }

  @media ${(props) => props.theme.queries.tabletAndUp} {
    padding: 64px 0;
  }
`;
